export var JoveProjectTypeEnum;

(function (JoveProjectTypeEnum) {
  JoveProjectTypeEnum["cms"] = "cms";
  JoveProjectTypeEnum["quote"] = "quote";
  JoveProjectTypeEnum["dashboard"] = "dashboard";
  JoveProjectTypeEnum["website"] = "website";
  JoveProjectTypeEnum["validation"] = "validation";
})(JoveProjectTypeEnum || (JoveProjectTypeEnum = {}));

export var QuoteFromSourceTypeEnum;

(function (QuoteFromSourceTypeEnum) {
  QuoteFromSourceTypeEnum["quote"] = "quote";
  QuoteFromSourceTypeEnum["policy"] = "policy";
})(QuoteFromSourceTypeEnum || (QuoteFromSourceTypeEnum = {}));